import { render, staticRenderFns } from "./TeamRoleTable.vue?vue&type=template&id=d215ed42&"
import script from "./TeamRoleTable.vue?vue&type=script&lang=js&"
export * from "./TeamRoleTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports